import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in EAKC-MVP: src/lib/jobs/sync-worker.ts, src/lib/rag/adaptive-chunker.ts,
// src/lib/rag/embeddings.ts, docs/content/06-sync-engine-architecture.md.
// LIVE constants verified in code (NOT the stale draft table): EMBED_BATCH_SIZE=16,
// INSERT_BATCH_SIZE=50, DELETE_BATCH_SIZE=25, keepAlive=false, maxSockets=4, DOC_CONCURRENCY=1.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "For two weeks, every sync of my repo died at exactly 20%. No stack trace. No error. Just silence." },
];

export const PIPELINE: ScriptLine[] = [
  { scene: "pipeline", fromSec: 0.4, holdSec: 6, caption: "The sync worker runs five steps: fetch, dedup, process each doc, extract entities, finalize." },
  { scene: "pipeline", fromSec: 6.5, holdSec: 5.5, caption: "Step 1 fetch ends at 20%. Step 3 — chunk, embed, store — is where 80% of the work lives." },
  { scene: "pipeline", fromSec: 12.3, holdSec: 5.5, caption: "It crashed the instant Step 3 touched the first document. Same place, every time." },
];

export const CAUSE: ScriptLine[] = [
  { scene: "cause", fromSec: 0.4, holdSec: 6, caption: "The cause was two functions calling each other. The markdown chunker, for big sections, fell back to the general one." },
  { scene: "cause", fromSec: 6.6, holdSec: 6, caption: "But the general chunker saw headings, decided 'this is markdown', and called back. Forever." },
  { scene: "cause", fromSec: 13, holdSec: 6, caption: "Stack overflow. Node dies with no catchable error — that's why there was no trace." },
];

export const FIX: ScriptLine[] = [
  { scene: "fix", fromSec: 0.4, holdSec: 6, caption: "The fix was one line: call chunkGeneral — the plain string splitter that does NOT inspect content." },
  { scene: "fix", fromSec: 6.6, holdSec: 6, caption: "It just splits. No 'smart' heading detection, no callback. The cycle is broken." },
  { scene: "fix", fromSec: 13, holdSec: 4.5, caption: "Two weeks of debugging. The fix was calling a function that does less." },
];

export const MEMORY: ScriptLine[] = [
  { scene: "memory", fromSec: 0.4, holdSec: 6, caption: "There was a second crash class: the loop used .map() plus a Semaphore set to concurrency 1." },
  { scene: "memory", fromSec: 6.6, holdSec: 6, caption: ".map() is eager — it allocates 670+ promises at once, even though only one runs. The VPS OOMed." },
  { scene: "memory", fromSec: 13, holdSec: 4.5, caption: "Replaced with a plain for-loop: one promise, one document in memory at a time." },
];

export const CONSTANTS: ScriptLine[] = [
  { scene: "constants", fromSec: 0.4, holdSec: 6, caption: "Every magic number in this file was earned from a production failure." },
  { scene: "constants", fromSec: 6.6, holdSec: 6.5, caption: "Embed 16 per batch. Insert 50 at a time. Delete in 25s — bigger hit Postgres limits." },
  { scene: "constants", fromSec: 13.3, holdSec: 6, caption: "keepAlive false: stale sockets caused ECONNRESET hangs. maxSockets 4: anything more starved other hosts." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 6, caption: "The result: 670+ GitHub files flow into roughly 2,110 vector chunks." },
  { scene: "payoff", fromSec: 6.6, holdSec: 6, caption: "On a budget Dokploy VPS — sync runs in-process inside Next.js, no separate worker box." },
  { scene: "payoff", fromSec: 13, holdSec: 4.5, caption: "Memory stays flat: process one doc, free its content, move on." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "The final code is simpler than what I started with. Complexity was the enemy the whole time." },
  { scene: "outro", fromSec: 5.8, holdSec: 4.2, caption: "Next: the one-line bug that faked an out-of-memory crash for two weeks." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
